export default __webpack_public_path__ + "static/media/highlights.004ce449.PNG";